var Toggler = {};

(function ( $ ) {
	var defaultParent = 'section';

	Toggler.init = function () {
		$( document ).on( 'click', '.js-toggle-btn', function ( e ) {
			var button = $( this );

			// Apply toggle actions only within button scope
			var buttonParent;
			if ( button.data( 'scope' ) ) {
				buttonParent = button.parents( button.data( 'scope' ) );
			} else {
				buttonParent = button.parents( defaultParent );
			}

			e.preventDefault();

			// Toggle classes
			$.each( buttonParent.find( '.js-toggle-class' ), function ( index, element ) {
				element = $( element );
				element.toggleClass( element.data( 'class' ) );
			} );

			// Exchange classes
			$.each( buttonParent.find( '.js-toggle-exchange-class' ), function ( index, element ) {
				element = $( element );
				element.toggleClass( element.data( 'class1' ) );
				element.toggleClass( element.data( 'class2' ) );
			} );

			// Remove elements
			buttonParent.find( '.js-toggle-remove' ).remove();
		} );
	};

	$( Toggler.init );
})( jQuery );